import { Injectable } from "@angular/core";
import { CoreHttpClient, ResponsibleGamingConfigService } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { NOTIFICATION_RESULT_TRIGGER, NotificationResultModel } from "./notification-result.model";

@Injectable({
	providedIn: "root",
})
export class NotificationResultService {
	constructor(
		private config: ResponsibleGamingConfigService,
		private httpClient: CoreHttpClient
	) {}

	set({ action, trigger }: NotificationResultModel): Observable<object> {
		return this.httpClient.post({
			url: this.config.getNotificationResultEndpoint(),
			data: {
				action,
				trigger: NOTIFICATION_RESULT_TRIGGER[trigger],
			},
		});
	}
}
